import '../../../stylesheets/nav/nav.css';
import UserNameItem            from './UserNameItem.js'
import SubscriptionDetailsItem from './SubscriptionDetailsItem.js'
import Logout                  from './Logout.js';

const ProfileMenu = ( { user, subscription, paymentMethod } ) => {

    
    return (
        <div className="profile-dropdown-menu-container">
            
            {/* List Items in Drop Down Body */}
            <div className="profile-menu-body">
                <UserNameItem user={user} />
                <SubscriptionDetailsItem user={user} subscription={subscription} paymentMethod={paymentMethod} />
            </div>

            <div className="profile-menu-divider"></div>

            {/* List Items in Drop Down Footer */}
            <div className="profile-menu-footer">
                <Logout/>
            </div>

        </div>
    );
};

export default ProfileMenu;